import { render } from "./slide13.vue?vue&type=template&id=17b43353&scoped=true"
import script from "./slide13.vue?vue&type=script&lang=js"
export * from "./slide13.vue?vue&type=script&lang=js"

import "./slide13.vue?vue&type=style&index=0&id=17b43353&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b43353"]])

export default __exports__